<template>
  <Component
    :is="nolink ? 'div' : 'nuxt-link'"
    :to="link" :data-event="`${track.slug.replace(/-/g, '_')}_track.click`" data-direct-send
  >
    <div class="track-card">
      <div class="track-card-container">
        <div v-if="!hideImage" class="track-card-image">
          <img
            loading="lazy" class="image" :src="require(`../assets/images/fa/fa-career-track-${track.id}.jpg`)"
            :alt="track.name"
          >
        </div>
        <div class="track-card-body">
          <div class="track-name">
            {{ track.name }}
          </div>
          <p class="body-2">
            {{ track.description }}
          </p>
          <div class="track-card-footer">
            <div class="courses">
              <MonitorIcon /> <span class="text">{{ track.totalCourses }} courses</span>
            </div>
            <div class="certificate">
              <MedalIcon /> <span class="text"> Certificate of Achievement</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Component>
</template>

<script>
import MedalIcon from '../assets/svg/medal.svg?vue-component';
import MonitorIcon from '../assets/svg/courses/monitor.svg?vue-component';

export default {
  components: {
    MedalIcon,
    MonitorIcon,
  },
  props: {
    track: { type: Object, required: true, default: () => {} },
    nolink: { type: Boolean },
    hideImage: { type: Boolean },
  },
  data() {
    return {
    };
  },
  computed: {
    link() {
      let link = '/career-tracks/';

      if (this.$route.name.startsWith('business') && this.$config.project === 'lms') {
        link = '/business/library/';
      }

      return `${link}${this.track.slug}/`;
    },
  },
};
</script>
<style lang="scss" scoped>
.track-card {
  background-color: var(--main-light-shade-2);
  border-radius: 10px;

  &:hover {
    .track-card-container {
      .track-card-body {
        .track-name {
          color: var(--accent);
        }
      }
    }
  }

  .track-card-container {
    display: flex;
    flex-direction: column;
    height: 100%;

    .track-card-image {
      background-color: var(--main-dark);
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
      overflow: hidden;

      .image {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .track-card-body {
      padding: var(--spacing-24) var(--spacing-24) var(--spacing-36) var(--spacing-24);
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      row-gap: 12px;

      .track-name {
        flex-grow: 1;
        font-size: 21px;
        font-weight: 500;
        color: var(--main-dark-shade-0);
      }

      .body-2 {
        height: 96px;
        color: var(--main-dark-light-4);
        margin-top: 0;
        margin-bottom: var(--spacing-12);
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        line-clamp: 4;
        -webkit-box-orient: vertical;
      }

      .track-card-footer {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        row-gap: 8px;

        .courses,
        .certificate {
          display: flex;
          align-items: center;
          column-gap: 8px;

          svg {
            width: 22px;
            height: 22px;
            vertical-align: middle;

            path[stroke] {
              stroke: var(--main-dark-shade-0);
            }
          }

          .text {
            color: var(--main-dark-shade-0);
            font-size: 16px;
          }
        }
      }
    }
  }
}

</style>
